import styled from 'styled-components';

import Picture from 'components/picture';
import { stylesForMaxLinesOfText } from 'utils/style/max-lines-text';

import theme from './theme';

const IMAGE_HEIGHT = '110px';
const MOBILE_IMAGE_HEIGHT = '90px';
const CARD_WIDTH = '200px';
const MOBILE_CARD_WIDTH = '180px';
const CONTAINER_PADDING = '0.6rem';
const IMAGE_MARGIN_WIDTH = 4;
const EXCLAMATION_ICON_SIZE = 1;
const EXCLAMATION_ICON_MARGIN = '2px 8px 0 0';

export const Container = styled.div`
  border-radius: ${Styles.borderRadius};
  width: ${CARD_WIDTH};
  min-width: ${CARD_WIDTH};
  padding: ${CONTAINER_PADDING};
  background: ${Styles.color.cardBackground};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.07);
  overflow: hidden;
  height: 100%;

  ${Styles.mobile`
    width: ${MOBILE_CARD_WIDTH};
    min-width: ${MOBILE_CARD_WIDTH};
  `}
`;

export const ImageContainer = styled.div`
  border-radius: ${Styles.borderRadius};
  width: 100%;
  height: ${IMAGE_HEIGHT};
  background-position: center 42%;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;

  ${Styles.mobile`
    height: ${MOBILE_IMAGE_HEIGHT};
  `}
`;

export const ProductImg = styled(Picture)`
  position: absolute;
  width: calc(100% - ${IMAGE_MARGIN_WIDTH * 2}px);
  height: calc(100% - ${IMAGE_MARGIN_WIDTH}px);
  margin: ${IMAGE_MARGIN_WIDTH}px;
  border-radius: ${Styles.borderRadius};
`;

export const CardContent = styled.div`
  padding: 0.3rem 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - ${IMAGE_HEIGHT});
  font-family: ${Styles.fontFamily.brand};

  ${Styles.mobile`
    height: calc(100% - ${MOBILE_IMAGE_HEIGHT});
  `}
`;

export const RewardName = styled.h4`
  text-align: center;
  margin: 0.2rem 0 0.6rem 0;
  ${stylesForMaxLinesOfText({ maxLines: 2, lineHeight: 1.2, fontSizeInRem: 1.25 })}
  font-size: 1.25rem;

  ${Styles.mobile`
    ${stylesForMaxLinesOfText({ maxLines: 2, lineHeight: 1.2, fontSizeInRem: 1.15 })}
    font-size: 1.15rem;
  `}
`;

export const NotAvailableText = styled.div`
  font-size: 1rem;
  color: ${theme.notAvailableTextColor};
  display: flex;
  padding: 3px 15px 5px;
  line-height: 1.2;

  ${Styles.mobile`
    padding: 0px;
  `}
`;

export const ExclamationIcon = styled.div`
  color: ${Styles.color.white};
  background-color: ${Styles.color.grey.three};
  height: ${EXCLAMATION_ICON_SIZE}rem;
  min-height: ${EXCLAMATION_ICON_SIZE}rem;
  width: ${EXCLAMATION_ICON_SIZE}rem;
  min-width: ${EXCLAMATION_ICON_SIZE}rem;
  font-size: 0.7rem;
  border-radius: 50%;
  margin: ${EXCLAMATION_ICON_MARGIN};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    padding: 0.5rem;
  }
`;
